import { BDIData } from '../../../utils/type';
import { ApiMessage, ApiResponseHandler } from '../../ApiResponseHandler';
import ThomApiClient from '../../ThomApiClient';

export const addAssesment = async (params: BDIData): Promise<ApiMessage> => {
  const url = `client/evaluation?
    `;
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post(url, params),
  );
};

export const editAssesment = async (
  params: BDIData,
  id: string,
): Promise<ApiMessage> => {
  const url = `client/evaluation?evaluationId=${id}`;
  return ApiResponseHandler(await ThomApiClient.getInstance().put(url, params));
};

export const getEvaluationData = async (): Promise<BDIData[]> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get(`client/evaluationList`),
  );
};

export const uploadTBR = async (
  id: string | undefined,
): Promise<ApiMessage> => {
  const url = `evaluation/upload?id=${id}`;
  return ApiResponseHandler(await ThomApiClient.getInstance().put(url));
};

export const deleteEvaluation = async (
  evaluationId: string,
): Promise<ApiMessage> => {
  const url = `client/evaluation?evaluationId=${evaluationId}`;
  return ApiResponseHandler(await ThomApiClient.getInstance().delete(url));
};
